<template>
  <div class="mix-item-list-container">
    <div class="item-container">
      <div class="item" v-for="item in dataList" :key="item.id" @click="showDetailItem(item)">
        <div class="item-detail" v-if="item.type === 6|| item.type === 7">
          <div class="cover-container" v-if="item.cover_url">
            <div class="cover">
              <img v-lazy="item.cover_url" alt=""/>
              <div class="cover-mask" v-if="item.title">
                {{item.title}}
              </div>
            </div>
            <div class="desc-container" v-if="item.description">
              <div class="desc">{{item.description}}</div>
            </div>
          </div>
          <div v-else class="text-box-container">
            <div class="text-box">
              <div class="text-box-title-container">
                {{item.title }}
              </div>
              <div class="text-box-desc-container">
                {{item.description}}
              </div>
            </div>
          </div>
          <div class="bottom-cell">
            <div class="nickname">
              {{getNickname(item)}}
            </div>
            <div class="digg-text" @click.stop="onClickDigg(item)">
              <icon-svg :class="item.is_digg? 'digg-icon-font-fill': 'digg-icon-font'"
                        :icon-class="item.is_digg ? 'like-fill':'like'"></icon-svg>
              {{diggText(item)}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    ugcItemTypeComic,
    ugcItemTypeComicWt,
    ugcItemTypeMomentCraw,
    ugcItemTypeMomentUgc,
    ugcItemTypeMovie,
    ugcItemTypeNovel,
    ugcItemTypeSeries
  } from "../../util/const"

  export default {
    name: "MixItemListTwoCol",
    components: {
    },
    props: {
      dataList: {
        type: Array,
        default: () => []
      },
    },
    methods: {
      showDetailItem(item) {
        if (item.type === ugcItemTypeNovel) {
          this.$router.push('/novel/' + item.id);
        } else if (item.type === 0) {
          this.$router.push('/video/' + item.id);
        } else if (item.type === ugcItemTypeMovie || item.type === ugcItemTypeSeries) {
          this.$router.push("/movie/" + item.id)
        } else if (item.type === ugcItemTypeComic || item.type === ugcItemTypeComicWt) {
          this.$router.push("/comic/" + item.id)
        } else if (item.type === ugcItemTypeMomentUgc || item.type === ugcItemTypeMomentCraw) {
          this.$router.push("/moment/" + item.id)
        }
      },

      getNickname(item) {
        if (!item || !item.user) {
          return ""
        }
        return item.user.nickname
      },

      diggText(item) {
        if (item && item.digg_count) {
          return item.digg_count
        } else {
          return ""
        }
      },

      onClickDigg(item) {
        if (!item.is_digg) {
          item.is_digg = true
          if (item.digg_count) {
            item.digg_count += 1
          } else {
            item.digg_count = 1
          }
        }
      }
    },
    computed: {}
  };
</script>

<style lang="scss" scoped>
  .mix-item-list-container {
    background: white;
  }


  .item-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .item {
      width: 48%;
      padding: 0 2px 0;
    }
  }

  .item-detail {
    background-color: #fff;
    /*box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);*/
    margin-top: 12px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    overflow: hidden;
    width: 100%;
  }

  .cover-container {
    .cover {
      position: relative;
      overflow: hidden;
      height: 180px;

      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
    }

    img {
      position: absolute;
      display: block;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);

      width: 100%;
      margin: 0 auto;

      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
    }

    .cover-mask {
      position: absolute;
      bottom: 0;
      left: 0;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.8), transparent);
      padding: 12px 8px 3px;
      color: white;
      min-width: 90%;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }

  .text-box-container {
    .text-box {
      font-size: 14px;
      padding: 8px 5px;
      min-height: 120px;
      max-height: 180px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background: #f2f2f2;
      color: rgba(0, 0, 0, 0.56);

      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
    }

    .text-box-title-container {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      overflow: hidden;
    }

    .text-box-desc-container {
      margin-top: 8px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      overflow: hidden
    }
  }

  .desc-container {
    padding: 4px 4px;
    color: rgba(0, 0, 0, 0.72);
    font-size: 12px;

    .desc{
      line-height: 18px;
      max-height: 36px;
      letter-spacing: 1px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden
    }
  }

  .bottom-cell {
    display: flex;
    align-items: center;
    width: 100%;
    color: rgba(0, 0, 0, 0.48);
    margin: 6px 0;
  }

  .nickname {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* number of lines to show */

    width: 70%;
    overflow: hidden;
    margin: 0 4px;
    font-size: 12px;
  }
</style>
